import { gql } from "@apollo/client";

// Mutation for creating a contract with a group (Niaga Hakam)
export const NgpamCreateContract = gql`
  mutation NgpamCreateContract($input: ngpam_create_contract_input!) {
    contract: ngpam_create_contract(input: $input) {
      contract_id
    }
  }
`;

// Mutation for creating a contract with an agent (NAM)
export const NamCreateContract = gql`
  mutation NamCreateContract($input: nam_create_contract_input!) {
    contract: nam_create_contract(input: $input) {
      contract_id
    }
  }
`;

// Mutation for updating drop-off data on NAM contract
export const NamSetDropoff = gql`
  mutation namAgentSetDropoff($input: nam_dropoff_input!) {
    contract: nam_set_dropoff(input: $input) {
      contract_id
    }
  }
`;

// Mutation for updating drop-off data on NGPAM contract
export const NgpamSetDropoff = gql`
  mutation niagaHakamSetDropoff($input: nam_dropoff_input!) {
    contract: ngpam_set_dropoff(input: $input) {
      contract_id
    }
  }
`;

export const getContractAgent = gql`
query NE_GetAgentContract($statementId: Int!) {
  contract: nam_contract_detail(filter: { statement_id: $statementId }) {
    contract_id
    status
    market_day
    party
    financials {
      net_quantity
    }
    harvests {
      loaded_quantity
      photos {
        uri
        type
        position {
          coordinates
        }
      }
      land_plot {
        id
        name
        polygon {
          coordinates
        }
        pickup_position {
          coordinates
        }
      }
    }
    statement {
      id
      total_amount
      photos {
        type
        uri
      }
      line_items {
        sku
        total
        quantity
        price_per_unit
        title
      }
    }
    agent_person {
     first_name
     last_name
     location {
       village
       district
     }
     avatar_uri
    }
    buyer {
      id
      name
      accepts_ne_mobile_dropoff
    }
    agent {
      id
      name
    }
  }
}
`

export const GetHakamContract = gql`
query NE_niagaAgentFarmerContractDetails($statementId: Int!) {
  contract: niaga_agent_seller_contract_detail(
    filter: {statement_id: $statementId}
  ) {
    contract_id
    status
    market_day
    sellers {
      party_context {
        transactor {
          person {
            location {
              village
              district
            }
            firstname
            lastname
            user {
              avatar_url
            }
          }
        }
      }
    }
    statement {
      statement {
        id
        state
        status
        total
        tax_total
        pre_tax_total
        photos {
          photo {
            type
            uri
            created_at
          }
        }
        line_items {
          sku
          total
          quantity
          price_per_unit
          line_item_sale_item_static_description {
            title
          }
        }
      }
    }
    primary_buyer {
      party_context {
        organisation {
          id
          name
        }
      }
    }
    harvests {
      id
      photoCollection {
        type
        uri
        created_at
      }
      fruit_bunch_uri
      fruit_pile_uri
      loaded_quantity
      land_plot {
        id
        polygon
        name
      }
    }
  }
}
`